/*
 * Pure transforms between the approval form and the shape `PATCH /hardware/component-types/{id}`
 * takes.
 *
 * Kept dependency-free on purpose: `moment` and `_` are webpack ProvidePlugin globals and are not
 * defined when mocha loads this module, so anything reachable from a test must not rely on them.
 */

const trimmed = (value) => {
	return String(value ?? '').trim();
};

/*
 * `approvedBy` is sent rather than derived server-side from the session, following the compliance
 * override API, whose `granted_by`/`revoked_by` audit columns are filled the same way. Spec §9
 * names only `approvedFirmwareVersion` in the body and D18 adds `approved_by`/`approved_at` to the
 * table without saying which side writes them, so this is the assumption and this function is the
 * one place it lives - see the ticket's open question. `approvedAt` is never sent: a timestamp
 * taken from the operator's clock is not an audit trail.
 *
 * The version is trimmed but never case-folded. Firmware versions are exact identity values that
 * D12 excludes from normalization, and the approved version is compared for equality against what
 * appliances report.
 */
export const formValuesToApprovalPayload = (values, approvedBy) => {
	return {
		approvedFirmwareVersion: trimmed(values?.approvedFirmwareVersion),
		approvedBy: trimmed(approvedBy)
	};
};
